module.exports = {
      id: "tag-usage",
      viewBox: "0 0 30.383 24.21",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#tag",
      toString: function () {
        return this.url;
      }
    }